  <span class="collapser__opacity"></span>
<span class="collapser__icon-arrow icon-arrow" [class.collapser_open]="isOpen"></span>
